import AddIcon from '@mui/icons-material/Add';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Button,
    Grid,
    IconButton,
    InputAdornment, List, ListItem, ListItemIcon,
    ListItemText,
    Popover,
    Stack,
    TextField,
    Typography,
    Modal,
    Fade,

} from '@mui/material';
import { styled } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import toast from 'react-hot-toast';
import { ReactComponent as DropDownIcon } from "../assets/icons/icon-angle-down.svg";
import { ReactComponent as DeleteIcon } from "../assets/icons/icon-delete.svg";
import { ReactComponent as InputSearchIcon } from "../assets/icons/icon-feather-search.svg";
import { ReactComponent as HashtagIcon } from "../assets/icons/icon-hashtag.svg";
import QuickFilterForm from '../components/_quickFilterForm/QuickFilterForm';
import { HandleMeasureIcon } from '../components/measureList/MeasureListConfig';
import { getMeasuresList } from '../config/services/measures';
import { CustomTooltip, debouncingFn } from '../utils/Reusables';
const RootStyle = styled('div')(({ theme }) => ({

}));
const useStyles = makeStyles((theme) => ({
    crossIcon: {
        '& svg': {
            fontSize: 18
        }
    },
    bgWhite: {
        backgroundColor: '#fff',
        borderRadius: '4px',
    },
    formInput: {
        paddingLeft: 0,
        '&::placeholder': {
            paddingLeft: '-10px',
        }
    },
    searchFieldListItem: {
        paddingTop: '0.6rem',
        paddingBottom: '0.6rem',
        '&:hover': {
            background: "#f1f1f1",
            backgroundColor: "#f1f1f1",
            zIndex: 9,
            "& $listItemDescription": {
                visibility: 'visible'
            },
            "& $searchFieldListMoreIcon": {
                visibility: 'visible'
            }
        },

    },
    listItemDescription: {
        visibility: 'visible',
        '&:hover': {
            visibility: 'visible'
        }
    },
    searchFieldListMoreIcon: {
        visibility: 'visible',
        '&:hover': {
            visibility: 'visible'
        }
    },
    menuDropdownItem: {
        fontSize: '14px',
        color: '#202124',
        '&:hover': {
            backgroundColor: '#f6f6f6'
        }
    }
}));
const QuickFilters = ({ reportDetails, updateReportDetails }) => {
    const buttonQuickFilterRef = useRef();
    const classes = useStyles();
    const [datasetSelectedId, setDatasetSelectedId] = useState(reportDetails?.reportDetails?.dataSetId?._id);
    const [searchMeasure, setSearchMeasure] = useState(null);
    const [filterButtonWidth, setFilterButtonWidth] = useState('200px')
    const [anchorAddQuickFilter, setAnchorAddQuickFilter] = useState(null);
    const [quickFilterList, setQuickFilterList] = useState(reportDetails?.reportDetails?.quickFilterList || [])
    const [measureList, setMeasureList] = useState([]);
    const INITIAL_DELETE_POPUP_STATE = { open: false, message: '', deleteCb: () => { } }
    const [deletePopupState, setDeletePopupState] = useState(INITIAL_DELETE_POPUP_STATE);

    const handleMeaureMenu = (event) => {
        const buttonWidth = buttonQuickFilterRef.current.clientWidth;
        setFilterButtonWidth(buttonWidth);
        setSearchMeasure('');
        setAnchorAddQuickFilter(event.currentTarget)
    }

    const closeMeasureMenu = (event) => {
        setSearchMeasure('');
        setAnchorAddQuickFilter(null)
    }

    const handleSearchMeasure = (e) => {
        let { value } = e.target
        setSearchMeasure(value)
    }

    const fetchMeasureList = () => {
        let params = { dataSetId: datasetSelectedId, search: searchMeasure, sortKey: 'name', sortOrder: 1 }
        getMeasuresList(params)
            .then((res) => {
                if (res?.data?.statusCode === 0) { //Error Case
                    toast.error(res?.data?.error?.errorMessage || 'Error while fetching measures')
                }
                setMeasureList(res?.result);
            });
    }
    const clickMeasureListHandler = (measure) => {
        let { dataSetName } = reportDetails?.reportDetails?.dataSetId
        let dimensionObj = {
            member: `${dataSetName}.${measure.name}`,
            type: measure.type,
            conditions: [{ label: null, operator: "", values: [] }],
            label: measure?.displayName || measure?.name,
            listType: 'SingleSelect'
        }
        setQuickFilterList((prevState) => [...prevState, dimensionObj])
        closeMeasureMenu()
    }

    const onChangeFilter = useCallback((event, index, type) => {
        setQuickFilterList((prevState) => {
            let fieldObj = prevState[index]
            switch (type) {
                case 'label':
                    fieldObj.label = event.target.value
                    break;
                case 'listType':
                    fieldObj.listType = event.target.value
                    break;
                default:
                    fieldObj.conditions = event
                    break;
            }
            prevState.splice(index, 1, fieldObj)
            return [...prevState]
        })
    })

    const onDeleteQuickFilter = (index) => {
        setQuickFilterList((prevState) => {
            prevState.splice(index, 1)
            return [...prevState]
        })
        if (quickFilterList.length < 1) {
            reportDetails.reportDetails.quickFilterList = quickFilterList
            updateReportDetails({ ...reportDetails })
        }
    }

    const onApplyQuickFilter = () => {
        // console.log(quickFilterList)
        reportDetails.reportDetails.quickFilterList = quickFilterList
        // updateReportDetails({ reportDetails: reportDetails.reportDetails })
        updateReportDetails({ ...reportDetails })
    }

    const onDeleteAllQuickFilter = () => {
        setQuickFilterList([])
        reportDetails.reportDetails.quickFilterList = []
        updateReportDetails({ ...reportDetails });
    }

    useEffect(
        debouncingFn(fetchMeasureList), [searchMeasure]
    );

    return (
        <RootStyle>
            <Box width="100%" height="10%" py={2}>
                <Grid container alignItems="center">
                    <Grid item xs>
                        <Typography gutterBottom variant="h5" className="filter-heading">Quick Metric Based Filters</Typography>
                    </Grid>
                    <Button className="width-100 report_form_ui_btn primary" variant="contained" color="primary" startIcon={<AddIcon />} onClick={handleMeaureMenu}
                        ref={buttonQuickFilterRef} >
                        Add Filter Condition
                    </Button>
                </Grid>
            </Box>
            <Box width="100%" height="50%" sx={{ p: 0 }} >
                <List component="nav" aria-label="main mailbox folders" className="field_list">
                    {
                        quickFilterList.length > 0 && quickFilterList.map((field, i) => (
                            <Box key={`${i}-${field.member}-Container`}>
                                <ListItem key={`${i}-${field.member}-List`} sx={{ p: 0 }}>
                                    <Box display="block" width="100%" className="filter-box-item">
                                        <Box>
                                            <Stack direction="row" className="width-100" spacing={1} flexShrink={0} sx={{ my: 0 }}>
                                                <Accordion className="width-100">
                                                    <AccordionSummary
                                                        className="filter-box-item-summary"
                                                        expandIcon={<DropDownIcon />}
                                                        aria-controls="panel1a-content"
                                                        id="panel1a-header"
                                                    >
                                                        <ListItemIcon sx={{ paddingTop: '5px', marginRight: '12px' }}>
                                                            <HashtagIcon color="primary" />
                                                        </ListItemIcon>
                                                        <ListItemText
                                                            primary={field.label}
                                                            secondary={field.member.split('.')[1]}
                                                        />
                                                        <CustomTooltip title="Delete filter">
                                                            <IconButton 
                                                                color="primary" 
                                                                aria-label="Delete filter" 
                                                                component="span" 
                                                                className="hover-white form-icon-btn"
                                                                sx={{ p: 0, marginRight: 4 }}
                                                                onClick={() => setDeletePopupState({
                                                                    open: true,
                                                                    message: `Are you sure to delete "${field.label}" quick metric based filter ?`,
                                                                    deleteCb: () => {
                                                                        onDeleteQuickFilter(i)
                                                                        setDeletePopupState(INITIAL_DELETE_POPUP_STATE)    
                                                                    }
                                                                })}
                                                            >
                                                                <DeleteIcon className="filter-action-icon" />
                                                            </IconButton>
                                                        </CustomTooltip>
                                                    </AccordionSummary>
                                                    <AccordionDetails>
                                                        <Box style={{ display: "block" }}>
                                                            <QuickFilterForm field={field} index={i} onChangeFilter={onChangeFilter} />
                                                        </Box>
                                                    </AccordionDetails>
                                                </Accordion>
                                            </Stack>
                                        </Box>
                                    </Box>
                                </ListItem>
                            </Box>
                        ))
                    }
                </List>
            </Box>
            {quickFilterList.length > 0 && <Box width="100%" height="10%">
                <Stack direction="row" width="100%" spacing={1} flexShrink={0} sx={{ my: 1 }}>
                    <Button width="100%" className="report_form_ui_btn primary text-btn-small mr-2" variant="contained" color="primary" onClick={onApplyQuickFilter} >
                        Apply Filters
                    </Button>
                    <Button
                        width="100%"
                        className="report_form_ui_btn primary text-btn-small"
                        variant="contained"
                        color="primary"
                        onClick={() => setDeletePopupState({
                            open: true,
                            message: 'Are you sure to delete all quick metric based filter ?',
                            deleteCb: () => {
                                onDeleteAllQuickFilter()
                                setDeletePopupState(INITIAL_DELETE_POPUP_STATE)
                            }
                        })}>
                        Delete all
                    </Button>
                </Stack>
            </Box>}
            <Popover open={Boolean(anchorAddQuickFilter)} anchorEl={anchorAddQuickFilter} onClose={closeMeasureMenu}
                PaperProps={{
                    style: {
                        width: filterButtonWidth, height: 'fit-content', maxHeight: '300px', borderTopLeftRadius: 0,
                        borderTopRightRadius: 0, marginTop: '10px', backgroundColor: 'transparent'
                    },
                }}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}>
                <div>
                    <Box width="100%" height="100%" block="true">
                        <TextField onChange={handleSearchMeasure} className="cm_rprt_setting_content report_form_ui_input" type="search" size="small"
                            placeholder="Search field"
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="start">
                                        <InputSearchIcon className="input_search_icon" />
                                    </InputAdornment>
                                ),
                                classes: {
                                    input: classes.formInput,
                                    adornedEnd: classes.bgWhite + " form_input"
                                }
                            }}
                        />
                    </Box>

                    <Box className="field_list report_filter_list height-fit max-width-100 mt-0" sx={{ maxHeight: '300px', backgroundColor: '#fff' }} >
                        <List component="nav" aria-label="main mailbox folders" className="field_list">
                            {
                                (measureList?.length)
                                    ? measureList?.map((measure, i) => (
                                        <ListItem className={classes.searchFieldListItem} button key={i} onClick={() => clickMeasureListHandler(measure)}
                                            alignItems="flex-start">
                                            <ListItemIcon sx={{ mt: '0px', mr: '4px' }} className={classes.searchFieldListIcon + " icon_color_main"}> {HandleMeasureIcon(measure)}</ListItemIcon>
                                            <Grid container>
                                                <Grid item xs={12}>
                                                    <Typography className="text-plain"> {measure?.displayName ? measure?.displayName : measure?.name} </Typography>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Typography variant="subtitle2" className={classes.listItemDescription + " text-sub"}>{measure?.description} </Typography>
                                                </Grid>
                                            </Grid>
                                        </ListItem>
                                    ))
                                    : <ListItem button >
                                        No DateTime Measure.
                                    </ListItem>
                            }
                        </List>
                    </Box>
                </div>
            </Popover>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className="modal-root"
                open={deletePopupState.open}
                onClose={() => setDeletePopupState(INITIAL_DELETE_POPUP_STATE)}
                closeAfterTransition
            >
                <Fade in={deletePopupState.open}>
                    <Box className="modal-paper modal-box modal-sm" id="transition-modal-delete-quick-filter">
                        <Box className="modal-content-simple">
                            <Typography variant="subtitle1" className="modal-heading-title-simple">{deletePopupState.message ?? `Are you sure to delete?`}</Typography>
                            <Box className="modal-footer-simple">
                                <Button onClick={() => setDeletePopupState(INITIAL_DELETE_POPUP_STATE)} color="primary" className="report_form_ui_btn cancel mr-2" variant="outlined" > Cancel </Button>
                                <Button onClick={deletePopupState.deleteCb} color="error" autoFocus className="report_form_ui_btn submit" variant="contained"> Delete </Button>
                            </Box>
                        </Box>
                    </Box>
                </Fade>
            </Modal>
        </RootStyle>

    )
}
export default QuickFilters